
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dF5uX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1mHQU = parcelRequire("1mHQU");

const $da4808005ebe12f4$export$3d6d78aad6c8b522 = {
    PAGE_PERMISSIONS: 'Insufficient page permissions: You are not allowed to perform that action.',
    SPACE_PERMSSIONS: 'Insufficient destination space permissions: You are not allowed to perform that action.',
    DELETED_PAGE: 'Source page is in trash',
    DELETED_PAGE_ALT: 'Source page not found',
    SPACE_NOT_FOUND: 'Destination Space not found',
    ARCHIVED_PAGE: 'Source page is archived, cannot be copied'
};


const $6b0b134fe98737dd$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    defaultErrorBlogifyFlagTitle: {
        id: "publish-page-as-blog.flags.error-message-title",
        defaultMessage: "We had an issue publishing the blog"
    },
    defaultErrorBlogifyFlagDescription: {
        id: "publish-page-as-blog.flags.error-message-description",
        defaultMessage: "Refresh the page and try again."
    },
    alternativeErrorBlogifyFlagTitle: {
        id: "publish-page-as-blog.flags.alternative-error-message-title",
        defaultMessage: "We can\u2019t convert this page"
    },
    pagePermissionsErrorBlogifyFlagDescription: {
        id: "publish-page-as-blog.flags.page-permissions-error-message-description",
        defaultMessage: "Restrictions have been applied to this item recently that prevent its conversion."
    },
    spacePermissionsErrorBlogifyFlagDescription: {
        id: "publish-page-as-blog.flags.space-permissions-error-message-description",
        defaultMessage: "You need additional permissions in the destination space to convert it."
    },
    pageDeletedErrorBlogifyFlagDescription: {
        id: "publish-page-as-blog.flags.page-deleted-error-message-description",
        defaultMessage: "While you were working with this content, it was deleted by someone else."
    },
    spaceRestrictionsErrorBlogifyFlagDescription: {
        id: "publish-page-as-blog.flags.space-restrictions-error-message-description",
        defaultMessage: "Restrictions in the destination space prevent this item from being converted."
    },
    archivedPageErrorBlogifyFlagDescription: {
        id: "publish-page-as-blog.flags.archived-page-error-message-description",
        defaultMessage: "While you were working with this page, it was archived by someone else."
    }
});
const $6b0b134fe98737dd$var$fireAnalyticsEvent = ({ createAnalyticsEvent: createAnalyticsEvent, isSuccess: isSuccess, actionSubject: actionSubject, attributes: attributes, source: source, actionSubjectId: actionSubjectId })=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            actionSubject: actionSubject,
            action: isSuccess ? 'success' : 'failed',
            source: source,
            ...attributes && {
                attributes: attributes
            },
            ...actionSubjectId && {
                actionSubjectId: actionSubjectId
            }
        }
    }).fire();
};
const $6b0b134fe98737dd$export$5f2fd371a3016b0c = ({ createAnalyticsEvent: createAnalyticsEvent, actionSubject: actionSubject, attributes: attributes, source: source, isSuccess: isSuccess, actionSubjectId: actionSubjectId })=>{
    $6b0b134fe98737dd$var$fireAnalyticsEvent({
        createAnalyticsEvent: createAnalyticsEvent,
        isSuccess: isSuccess,
        actionSubject: actionSubject,
        attributes: attributes,
        source: source,
        actionSubjectId: actionSubjectId
    });
};
const $6b0b134fe98737dd$export$23111a6b0dd1d6ee = ({ flags: flags, createAnalyticsEvent: createAnalyticsEvent, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes, source: source, customFlagMessage: customFlagMessage })=>{
    $6b0b134fe98737dd$var$fireAnalyticsEvent({
        createAnalyticsEvent: createAnalyticsEvent,
        isSuccess: false,
        actionSubject: actionSubject,
        attributes: attributes,
        source: source,
        actionSubjectId: actionSubjectId
    });
    flags && flags.showErrorFlag({
        title: customFlagMessage && customFlagMessage.title ? customFlagMessage.title : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $6b0b134fe98737dd$export$311c03294014fd7d(attributes?.error).title),
        description: customFlagMessage && customFlagMessage.description ? customFlagMessage.description : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $6b0b134fe98737dd$export$311c03294014fd7d(attributes?.error).description)
    });
};
const $6b0b134fe98737dd$export$cea7730911ac669 = (errorMessage)=>{
    let knownEditorErrorMessage = '';
    errorMessage && Object.values((0, $1mHQU.ALLOWED_FLAG_MESSAGES)).some(function(value) {
        if (errorMessage.includes(value)) {
            knownEditorErrorMessage = value;
            return true;
        }
    });
    return knownEditorErrorMessage;
};
const $6b0b134fe98737dd$export$c58098ccf6d18998 = (adf)=>{
    if (!adf) throw new Error('Could not get the Editor Content');
};
const $6b0b134fe98737dd$export$311c03294014fd7d = (errorMessage)=>{
    if (errorMessage?.includes((0, $da4808005ebe12f4$export$3d6d78aad6c8b522).PAGE_PERMISSIONS)) return {
        title: $6b0b134fe98737dd$export$a7357cdd1f0b0168.alternativeErrorBlogifyFlagTitle,
        description: $6b0b134fe98737dd$export$a7357cdd1f0b0168.pagePermissionsErrorBlogifyFlagDescription
    };
    if (errorMessage?.includes((0, $da4808005ebe12f4$export$3d6d78aad6c8b522).SPACE_PERMSSIONS)) return {
        title: $6b0b134fe98737dd$export$a7357cdd1f0b0168.alternativeErrorBlogifyFlagTitle,
        description: $6b0b134fe98737dd$export$a7357cdd1f0b0168.spacePermissionsErrorBlogifyFlagDescription
    };
    if (errorMessage?.includes((0, $da4808005ebe12f4$export$3d6d78aad6c8b522).DELETED_PAGE) || errorMessage?.includes((0, $da4808005ebe12f4$export$3d6d78aad6c8b522).DELETED_PAGE_ALT)) return {
        title: $6b0b134fe98737dd$export$a7357cdd1f0b0168.alternativeErrorBlogifyFlagTitle,
        description: $6b0b134fe98737dd$export$a7357cdd1f0b0168.pageDeletedErrorBlogifyFlagDescription
    };
    if (errorMessage?.includes((0, $da4808005ebe12f4$export$3d6d78aad6c8b522).SPACE_NOT_FOUND)) return {
        title: $6b0b134fe98737dd$export$a7357cdd1f0b0168.alternativeErrorBlogifyFlagTitle,
        description: $6b0b134fe98737dd$export$a7357cdd1f0b0168.spaceRestrictionsErrorBlogifyFlagDescription
    };
    if (errorMessage?.includes((0, $da4808005ebe12f4$export$3d6d78aad6c8b522).ARCHIVED_PAGE)) return {
        title: $6b0b134fe98737dd$export$a7357cdd1f0b0168.alternativeErrorBlogifyFlagTitle,
        description: $6b0b134fe98737dd$export$a7357cdd1f0b0168.archivedPageErrorBlogifyFlagDescription
    };
    return {
        title: $6b0b134fe98737dd$export$a7357cdd1f0b0168.defaultErrorBlogifyFlagTitle,
        description: $6b0b134fe98737dd$export$a7357cdd1f0b0168.defaultErrorBlogifyFlagDescription
    };
};
module.exports["publishFromPageToBlogEvent"] = $6b0b134fe98737dd$export$5f2fd371a3016b0c;
module.exports["publishPageAsBlogFailureEventAndFlag"] = $6b0b134fe98737dd$export$23111a6b0dd1d6ee;
module.exports["blogifyErrorMessage"] = $6b0b134fe98737dd$export$311c03294014fd7d;
module.exports["knownEditorError"] = $6b0b134fe98737dd$export$cea7730911ac669;
module.exports["handleEditorPublishPageAsBlogError"] = $6b0b134fe98737dd$export$c58098ccf6d18998;

});

parcelRegister("3Gp1y", function(module, exports) {
/**
 * @generated SignedSource<<0d2f2df44e9bf2c541aa094c4f580bbb>>
 * @relayHash 47c949c21db5d28c8b91b5a6492b2d11
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 133c76ca542b5dff635ac12c76a67cc79992d30e6af1fb0d35e9d337342113ba
const $aa5f10a793fdffa4$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "content"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "destinationSpaceKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "message"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ncsStepVersion"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "permissions"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "restrictionState"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "restrictions"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "schedulePublishDate"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sourceStatus"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "suppressNotifyWatchers"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "syncRev"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "title"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "version"
    }, v15 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "fields": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentBody",
                            "variableName": "content"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "minorEdit",
                            "variableName": "suppressNotifyWatchers"
                        },
                        {
                            "kind": "Variable",
                            "name": "ncsStepVersion",
                            "variableName": "ncsStepVersion"
                        },
                        {
                            "kind": "Variable",
                            "name": "permissions",
                            "variableName": "permissions"
                        },
                        {
                            "kind": "Variable",
                            "name": "restrictionState",
                            "variableName": "restrictionState"
                        },
                        {
                            "kind": "Variable",
                            "name": "restrictions",
                            "variableName": "restrictions"
                        },
                        {
                            "kind": "Variable",
                            "name": "schedulePublishDate",
                            "variableName": "schedulePublishDate"
                        },
                        {
                            "kind": "Variable",
                            "name": "syncRev",
                            "variableName": "syncRev"
                        },
                        {
                            "kind": "Variable",
                            "name": "title",
                            "variableName": "title"
                        },
                        {
                            "kind": "Variable",
                            "name": "version",
                            "variableName": "version"
                        },
                        {
                            "kind": "Variable",
                            "name": "versionMessage",
                            "variableName": "message"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "confluenceContentInput"
                },
                {
                    "kind": "Variable",
                    "name": "destinationSpaceKey",
                    "variableName": "destinationSpaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "sourceStatus",
                    "variableName": "sourceStatus"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "success"
    }, v17 = {
        "kind": "ScalarField",
        "name": "id"
    }, v18 = {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "status"
            },
            v17 /*: any*/ ,
            {
                "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "webui"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "editui"
                    }
                ]
            }
        ]
    }, v19 = {
        "kind": "ScalarField",
        "name": "message"
    }, v20 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useConvertPageToBlogMutation",
            "selections": [
                {
                    "args": v15 /*: any*/ ,
                    "concreteType": "ConfluenceConvertContentToBlogpostPayload",
                    "kind": "LinkedField",
                    "name": "confluence_convertToBlogpost",
                    "plural": false,
                    "selections": [
                        v16 /*: any*/ ,
                        v18 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v19 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v20 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v5 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v9 /*: any*/ ,
                v8 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v10 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useConvertPageToBlogMutation",
            "selections": [
                {
                    "args": v15 /*: any*/ ,
                    "concreteType": "ConfluenceConvertContentToBlogpostPayload",
                    "kind": "LinkedField",
                    "name": "confluence_convertToBlogpost",
                    "plural": false,
                    "selections": [
                        v16 /*: any*/ ,
                        v18 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v19 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v20 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v17 /*: any*/ 
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "47c949c21db5d28c8b91b5a6492b2d11",
            "id": "133c76ca542b5dff635ac12c76a67cc79992d30e6af1fb0d35e9d337342113ba",
            "metadata": {},
            "name": "useConvertPageToBlogMutation",
            "operationKind": "mutation",
            "text": "mutation useConvertPageToBlogMutation($contentId:ID!,$content:String,$message:String,$suppressNotifyWatchers:Boolean,$syncRev:String,$ncsStepVersion:String,$title:String,$version:Int,$schedulePublishDate:String,$restrictions:PageRestrictionsInput,$permissions:ConfluenceContentPermissionsInput,$restrictionState:ConfluenceContentRestrictionStateInput,$cloudId:ID!,$destinationSpaceKey:String!,$sourceStatus:String!){confluence_convertToBlogpost(cloudId:$cloudId,input:{confluenceContentInput:{contentBody:$content,contentId:$contentId,minorEdit:$suppressNotifyWatchers,syncRev:$syncRev,ncsStepVersion:$ncsStepVersion,restrictions:$restrictions,restrictionState:$restrictionState,permissions:$permissions,schedulePublishDate:$schedulePublishDate,title:$title,version:$version,versionMessage:$message},destinationSpaceKey:$destinationSpaceKey,sourceStatus:$sourceStatus}){success,content{status,id,links{webui,editui}},errors{message,extensions{__typename,statusCode,...on BulkMutationErrorExtension{id}}}}}"
        }
    };
}();
$aa5f10a793fdffa4$var$node.hash = "0df7bc0648fed90fface6ce0c455deca";
var $aa5f10a793fdffa4$export$2e2bcd8739ae039 = $aa5f10a793fdffa4$var$node;



var $6mKj3 = parcelRequire("6mKj3");


var $308Wd = parcelRequire("308Wd");


var $bQm3c = parcelRequire("bQm3c");


var $dF5uX = parcelRequire("dF5uX");


var $iVd6X = parcelRequire("iVd6X");

const $8fb7d9dcdd9bebc2$export$e8a4ab21f72a2af3 = ()=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [convertToBlogpostMutation] = (0, $308Wd.useMutationInterop)((0, $aa5f10a793fdffa4$export$2e2bcd8739ae039), {
        __callerPackage__: "publish-page-as-blog"
    });
    const handlePageToBlogConversion = async ({ flags: flags, sourceAction: sourceAction, contentId: contentId, spaceKey: spaceKey, message: message, suppressNotifyWatchers: suppressNotifyWatchers, schedulePublishDate: schedulePublishDate, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, onConvertAndPublishSucceed: onConvertAndPublishSucceed, onPublishFail: onPublishFail, onConvertFail: onConvertFail, restrictions: restrictions })=>{
        // Extract new permissions fields from GqlRestrictionsInput when using the
        // persistence_specific_access_gate experiment (new explicit permissions paradigm)
        const isGqlRestrictionsInput = (value)=>value !== undefined && ('permissions' in value || 'restrictionState' in value);
        const gqlInput = isGqlRestrictionsInput(restrictions) && (0, $6mKj3.expValEquals)('persistence_specific_access_gate', 'cohort', 'experiment') ? restrictions : undefined;
        const permissionsInput = gqlInput?.permissions ?? undefined;
        const restrictionStateInput = gqlInput?.restrictionState ?? undefined;
        // When using new permissions paradigm, don't send legacy restrictions
        const legacyRestrictions = permissionsInput || restrictionStateInput ? undefined : restrictions;
        const variables = {
            contentId: contentId,
            destinationType: 'blogpost',
            sourceStatus: sourceAction === (0, $iVd6X.PublishPageAsBlogSources).EditPage ? 'draft' : 'current',
            destinationSpaceKey: spaceKey || '',
            cloudId: cloudId,
            permissions: permissionsInput,
            restrictionState: restrictionStateInput
        };
        try {
            if (sourceAction === (0, $iVd6X.PublishPageAsBlogSources).EditPage) {
                const { title: title, adf: adf, syncRev: syncRev, ncsStepVersion: ncsStepVersion } = await retrieveEditorTitleAndContent();
                (0, $dF5uX.handleEditorPublishPageAsBlogError)(adf);
                variables['content'] = JSON.stringify(adf);
                variables['title'] = title;
                variables['syncRev'] = syncRev;
                variables['ncsStepVersion'] = ncsStepVersion;
                variables['message'] = message;
                variables['suppressNotifyWatchers'] = suppressNotifyWatchers;
                variables['schedulePublishDate'] = schedulePublishDate;
                variables['restrictions'] = legacyRestrictions;
            }
            const { data: data } = await convertToBlogpostMutation({
                variables: variables
            });
            const hasConvertedAndPublished = data?.confluence_convertToBlogpost?.content?.status === 'current';
            const links = data?.confluence_convertToBlogpost?.content?.links;
            // it's possible for the conversion to go through but not the publishing of the blog draft
            if (data && hasConvertedAndPublished) onConvertAndPublishSucceed(data);
            else if (links?.editui && !schedulePublishDate) onPublishFail({
                links: links,
                errorMessage: 'Page has converted to blog but not published',
                flags: flags
            });
            else if (data?.confluence_convertToBlogpost?.errors?.[0]) onConvertFail({
                error: new Error(data?.confluence_convertToBlogpost?.errors?.[0]?.message || 'Unknown error when converting page to blog'),
                flags: flags
            });
        } catch (error) {
            onConvertFail({
                error: error,
                flags: flags
            });
        }
    };
    return handlePageToBlogConversion;
};
module.exports["useConvertPageToBlog"] = $8fb7d9dcdd9bebc2$export$e8a4ab21f72a2af3;

});


//# sourceMappingURL=PublishButtonWithMoreOptions.b885c859.js.map
